/**
 * @generated SignedSource<<db1ecf43bbddb4fb7edb2ae0fdec2047>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_viewer">;
  readonly " $fragmentType": "useItemMediaItems_viewer";
};
export type useItemMediaItems_viewer$key = {
  readonly " $data"?: useItemMediaItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemMediaItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowVimeoVideo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1a5d9fa844f2d2a7928e6e6d8cb973ab";

export default node;
